const SMALL_MOBILE_SCREEN_SIZE = 360;
const MOBILE_SCREEN_SIZE = 600;
const TABLET_SCREEN_SIZE = 1050;
const DIALOG_SCREEN_SIZE = 625;
const SMALL_TABLET_SCREEN_SIZE = 768;
const DESKTOP_SCREEN_SIZE = 1680;
const XL_DESKTOP_SCREEN_SIZE = 1920;
const DESKTOP_HORIZONTAL_PADDING = 140;
const MOBILE_HORIZONTAL_PADDING = 20;
const TABLET_HORIZONTAL_PADDING = 40;
const WIDGET_SPACE = 50;
const WIDGET_SPACE_HALF = WIDGET_SPACE / 2;
const WIDGET_MEDIA_BORDER_RADIUS = 5; // image / videp
const DEFAULT_LINK_ID = '#';
var BRANDCLUB_RETAILERS;
(function (BRANDCLUB_RETAILERS) {
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Amazon"] = 1] = "Amazon";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Walmart"] = 2] = "Walmart";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["BestBuy"] = 3] = "BestBuy";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Target"] = 4] = "Target";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Costco"] = 9] = "Costco";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Chewy"] = 18] = "Chewy";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Kroger"] = 48] = "Kroger";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Sephora"] = 50] = "Sephora";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Safeway"] = 92] = "Safeway";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Qfc"] = 93] = "Qfc";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Albertsons"] = 94] = "Albertsons";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["FredMeyer"] = 127] = "FredMeyer";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Ralphs"] = 128] = "Ralphs";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["KrogerFamily"] = 129] = "KrogerFamily";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["AlbertsonsFamily"] = 170] = "AlbertsonsFamily";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["HomeDepot"] = 6] = "HomeDepot";
})(BRANDCLUB_RETAILERS || (BRANDCLUB_RETAILERS = {}));
const WIDGET_PAIR_PRODUCT_PADDING = 50;
const PLACEHOLDER_GREEN_IMAGE = {
    '1X1': 'https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_1x1.png',
};
const BRANDCLUB_BRAND_ID = 50000;
const UNIVERSAL_STORE_SITE = 'https://brandclub.com';

export { BRANDCLUB_BRAND_ID, BRANDCLUB_RETAILERS, DEFAULT_LINK_ID, DESKTOP_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DIALOG_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, PLACEHOLDER_GREEN_IMAGE, SMALL_MOBILE_SCREEN_SIZE, SMALL_TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, TABLET_SCREEN_SIZE, UNIVERSAL_STORE_SITE, WIDGET_MEDIA_BORDER_RADIUS, WIDGET_PAIR_PRODUCT_PADDING, WIDGET_SPACE, WIDGET_SPACE_HALF, XL_DESKTOP_SCREEN_SIZE };
//# sourceMappingURL=Constants.js.map
